// Centralized valueset parameter codes for Masters/Vanchi services
// Code → Parameter key

export enum ValuesetParam {
  PACK_STATUS = 'L1100L21',
  PACK_COMMENT = 'L1100L22',
  USER_ROLE = 'L1100L26',
  NADA = 'L1100L23',
}

// Optional helper to map code → human-friendly key
export const VALUES_PARAM_KEY: Record<ValuesetParam, string> = {
  [ValuesetParam.PACK_STATUS]: 'packstatus',
  [ValuesetParam.PACK_COMMENT]: 'packcomment',
  [ValuesetParam.USER_ROLE]: 'userrole',
  [ValuesetParam.NADA]: 'nada',
};


